<template>
  <mdb-modal :show="show" @close="close()">
    <mdb-modal-header class="aqua-gradient">
      <mdb-modal-title>Select Relation Type</mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body class="overflow-hidden d-flex">
      <mdb-container>
        <bridge8-autocomplete
          outline
          class="m-0 route-point-select w-100"
          label="Enter Relationship Type"
          :min-chars-to-search="1"
          v-model="type"
          @change="type = $event"
          :data="types"
        />
        <mdb-select
          size="sm"
          label="Direction"
          v-model="directions"
          @getValue="direction = $event"
        />
      </mdb-container>
    </mdb-modal-body>
    <mdb-modal-footer>
      <mdb-btn
        :disabled="!type || !direction"
        rounded
        size="sm"
        gradient="aqua"
        @click.native="close(type, direction)"
        title="Submit relationship type and direction"
      >Select</mdb-btn>
    </mdb-modal-footer>
  </mdb-modal>
</template>

<script>
import {
  mdbContainer,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbBtn,
  mdbSelect
} from 'mdbvue'
import Bridge8Autocomplete from './Bridge8Autocomplete'
import {mapActions} from 'vuex'
import {RelationshpDirections} from '../enums'
import {errorCatch} from '../utils'

export default {
  name: 'AdminSelectRelationTypeModal',
  data () {
    return {
      types: [],
      type: '',
      directions: [
        {text: 'Incoming', value: RelationshpDirections.INCOMING},
        {text: 'Outgoing', value: RelationshpDirections.OUTGOING}
      ],
      direction: null,
      show: false,
      callback: obj => { console.log(`Type selected: ${[obj.type, obj.direction].join(', ')}`) }
    }
  },
  methods: {
    ...mapActions(['apiGetRelationshipTypes']),
    close (type = null, direction = null) {
      this.show = false
      if (typeof type === 'string' && Object.values(RelationshpDirections).includes(direction)) {
        this.callback({type: type, direction: direction})
      }
      this.type = null
      this.direction = null
      this.callback = obj => { console.log(`Type selected: ${[obj.type, obj.direction].join(', ')}`) }
    }
  },
  mounted () {
    this.$bus.$on('admin-modal-select-rel-type', callback => {
      this.callback = callback
      this.show = true
    })
    this.apiGetRelationshipTypes().then(types => { this.types = types })
      .catch(errorCatch('Get Relationship Types failed in Select Relationship Type Modal', this))
  },
  beforeDestroy () {
    this.$bus.$off('admin-modal-select-rel-type')
  },
  components: {
    mdbContainer,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
    mdbSelect,
    Bridge8Autocomplete
  }
}
</script>

<style lang="sass">
.modal-body
  max-height: 50vh
</style>



// WEBPACK FOOTER //
// src/components/AdminSelectRelationTypeModal.vue